export const SAVE_PROMOTION_INFORMATION = "SAVE_PROMOTION_INFORMATION";
export const SAVE_SELECTED_RECEPIENDS = "SAVE_SELECTED_RECEPIENDS";
export const SAVE_COMMON_POINTS_FOR_ALL_RECEPIENTS =
  "SAVE_COMMON_POINTS_FOR_ALL_RECEPIENTS";
export const SET_CHECKBOX_FOR_EACH_RECEPIENTS =
  "SET_CHECKBOX_FOR_EACH_RECEPIENTS";
export const SAVE_POINTS_FOR_SINGLE_MULTI_USER =
  "SAVE_POINTS_FOR_SINGLE_MULTI_USER";
export const SAVE_BEHAVIOUR_DETAILS = "SAVE_BEHAVIOUR_DETAILS";
export const ADD_POINTS_FOR_CUSTOM_USER = "ADD_POINTS_FOR_CUSTOM_USER";
export const SET_CHECKBOX_FOR_RECOGNITION_PRIVATE =
  "SET_CHECKBOX_FOR_RECOGNITION_PRIVATE";
export const SAVE_UPLOADED_IMAGE_INFO = "SAVE_UPLOADED_IMAGE_INFO";
export const GET_ALL_SELECTED_PROMOTION = "GET_ALL_SELECTED_PROMOTION";
export const ALL_PROMOTION = "ALL_PROMOTION";
export const SENT_RECOGNITION_INFORMATION = "SENT_RECOGNITION_INFORMATION";
export const SAVE_LOGIN_RESPONSE = "SAVE_LOGIN_RESPONSE";
export const SAVE_TEAM_MEMBER_LIST = "SAVE_TEAM_MEMBER_LIST";
export const SAVE_RECOGNIZE_LIST = "SAVE_RECOGNIZE_LIST";
export const USER_DETAILS = "USER_DETAILS";
export const FILTERS = "FILTERS";
export const SAVE_COPYOTHERS_RECEPIENDS = "SAVE_COPYOTHERS_RECEPIENDS";
export const REMOVE_COPYOTHERS_RECEPIENDS = "REMOVE_COPYOTHERS_RECEPIENDS";
export const SET_COPY_MANAGER = "SET_COPY_MANAGER";
export const SET_COPY_ME = "SET_COPY_ME";
export const COPY_OTHERS_EMAIL = "COPY_OTHERS_EMAIL";
export const CLEAR_COPY_OTHERS_EMAIL = "CLEAR_COPY_OTHERS_EMAIL";
export const SELECTED_PARTICIPANT_ID = "SELECTED_PARTICIPANT_ID";
export const RESTORE_RECEPIENDS = "RESTORE_RECEPIENDS";
